export enum TimeoutPolicy {
  TIME_OUT_WF = "TIME_OUT_WF",
  ALERT_ONLY = "ALERT_ONLY",
}
